// extracted by mini-css-extract-plugin
export var btnNext = "discountsSwiper-module--btnNext--HR69h";
export var btnPrev = "discountsSwiper-module--btnPrev--aky-Y";
export var root = "discountsSwiper-module--root--lIz7v";
export var slide = "discountsSwiper-module--slide--JK1jc";
export var swiperContainer = "discountsSwiper-module--swiper-container--yjuL-";
export var swiperOuter = "discountsSwiper-module--swiperOuter--KFOQT";